import { useFieldArray, useFormContext, useWatch } from 'react-hook-form';
import { useAddressQuery } from '~/queries/useAddressQuery';
import { TManagersAndRepresentatives } from '../types';
import { Box, Grid, Typography } from '@mui/material';
import FormContainer from '~/modules/identification/components/FormComponents/FormContainer';
import PersonalInfoBlock from '~/modules/identification/components/FormComponents/PersonalInfoBlock';
import IdentificationNumberBlock from '~/modules/identification/components/FormComponents/IdentificationNumberBlock';
import FormAutocomplete from '~/components/FormComponents/FormAutocomplete';
import { AddressInfo } from '~/modules/identification/components/FormComponents/AddressInfo';
import { AddRemoveBlock } from '~/components/AddRemoveBlock/AddRemoveBlock';
import { EMPTY_CLIENT_REPRESENTATIVE } from '../constants';
import FormGridItem from '~/components/FormComponents/FormGridItem';
import { commonStyles } from '~/theme/styles/commonStyles';

const ClientRepresentatives = () => {
  const { control } = useFormContext<TManagersAndRepresentatives>();
  const { nonAgressionCountryOptions, countryOptions } = useAddressQuery();
  const isClientRepresentativesAbsent = useWatch({
    control,
    name: 'isClientRepresentativesAbsent',
  });

  const { fields, append, remove } = useFieldArray({
    control,
    name: 'clientRepresentatives',
  });

  if (isClientRepresentativesAbsent) return null;

  return (
    <>
      <Typography variant="h5" sx={{ textAlign: 'center' }}>
        Ідентифікаційні дані представників клієнта (на підставі довіреності)
      </Typography>
      <Box sx={commonStyles.columnFlexContainer}>
        {fields.map((represent, index) => (
          <FormContainer title={`Представник ${index + 1}`} hasBookmark key={represent.id}>
            <PersonalInfoBlock section={`clientRepresentatives.${index}`} isBirthDateHidden />
            <Grid size={{ xs: 0, sm: 0, md: 6 }} />
            <IdentificationNumberBlock section={`clientRepresentatives.${index}`} />
            <FormGridItem>
              <FormAutocomplete
                name={`clientRepresentatives.${index}.citizenshipCountry`}
                options={countryOptions}
                disabled={isClientRepresentativesAbsent}
                inputProps={{
                  placeholder: 'Оберіть країну громадянства',
                }}
                label="Країна громадянства"
                fullWidth
              />
            </FormGridItem>
            <FormGridItem>
              <FormAutocomplete
                name={`clientRepresentatives.${index}.residenceCountry`}
                options={nonAgressionCountryOptions}
                disabled={isClientRepresentativesAbsent}
                placeholder="Оберіть країну резидентства"
                inputProps={{
                  placeholder: 'Оберіть країну резидентства',
                }}
                label="Країна резидентства"
                fullWidth
              />
            </FormGridItem>
            <AddressInfo section={`clientRepresentatives.${index}`} />
            <Grid size={12}>
              <AddRemoveBlock
                add={() => append(EMPTY_CLIENT_REPRESENTATIVE)}
                remove={() => remove(index)}
                isPlusShown={fields.length <= 30}
                isMinusShown={fields.length > 1}
                plusText='Натисніть на "+" для додавання ідентифікаційні дані представників клієнта (на підставі довіреності)'
                minusText='Натисніть на "-" для видалення ідентифікаційні дані представників клієнта (на підставі довіреності)'
              />
            </Grid>
          </FormContainer>
        ))}
      </Box>
    </>
  );
};

export default ClientRepresentatives;
